export default __webpack_public_path__ + "static/media/ghostjacket.b034a7ab.png";